import { c as _c } from "react/compiler-runtime";
import { ArrowRightIcon } from '@vidstack/react/icons';
import classnames from 'classnames';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { ExternalLinkIcon } from '@shared/ui-components/svgs';
import { Button } from '../../components/button/button';
import { type ImageTextCardBlockLinkBlock, type KeyLinkValueBlockLinkBlock, type LinkBlock as LinkBlockData, type MembershipRequirementBlockLinkBlock, type NextCallOutBlockLinkBlock, type TextCardBlockLinkBlock } from '../../utils/data/graphql/_generated/gql-generated';
import styles from './link-block.module.scss';
export enum LinkBlockStyle {
  PrimaryButton = 'next-button-primary',
  SecondaryButton = 'next-button-secondary',
  TextIcon = 'next-text-icon',
  TextIconSmall = 'next-text-icon-small',
  TextSmall = 'next-text-small',
}
type LinkBlockProps = {
  blockData: ImageTextCardBlockLinkBlock | KeyLinkValueBlockLinkBlock | LinkBlockData | MembershipRequirementBlockLinkBlock | NextCallOutBlockLinkBlock | TextCardBlockLinkBlock;
  className?: string;
  linkStyleOverride?: LinkBlockStyle;
  onDark?: boolean;
};
export const LinkBlock = t0 => {
  const $ = _c(41);
  const {
    blockData,
    className,
    linkStyleOverride,
    onDark
  } = t0;
  const styleToRender = linkStyleOverride ? linkStyleOverride : blockData?.LinkStyle as LinkBlockStyle;
  const isExternal = blockData?.Target === "_blank";
  let t1;
  if ($[0] !== blockData.DownloadFileName) {
    t1 = blockData.DownloadFileName && {
      download: blockData.DownloadFileName ?? ""
    };
    $[0] = blockData.DownloadFileName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== blockData.Target) {
    t2 = blockData.Target && {
      target: blockData.Target ?? ""
    };
    $[2] = blockData.Target;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = blockData?.DisplayText;
  const t4 = blockData?.LinkToContent ?? "";
  let t5;
  if ($[4] !== onDark || $[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      ...t1,
      ...t2,
      children: t3,
      isInverted: onDark,
      to: t4
    };
    $[4] = onDark;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const commonProps = t5;
  let t6;
  if ($[10] !== className) {
    t6 = classnames(className);
    $[10] = className;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isExternal) {
    t7 = isExternal ? <ExternalLinkIcon /> : <ArrowRightIcon className={styles["internal-icon"]} />;
    $[12] = isExternal;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== commonProps || $[15] !== isExternal || $[16] !== t6 || $[17] !== t7) {
    t8 = {
      className: t6,
      isExternal,
      suffix: t7,
      variant: ButtonVariant.Tertiary,
      ...commonProps
    };
    $[14] = commonProps;
    $[15] = isExternal;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const textIconProps = t8;
  switch (styleToRender) {
    case "next-button-primary":
      {
        let t9;
        if ($[19] !== className) {
          t9 = classnames(className, styles.button);
          $[19] = className;
          $[20] = t9;
        } else {
          t9 = $[20];
        }
        let t10;
        if ($[21] !== commonProps || $[22] !== isExternal || $[23] !== t9) {
          t10 = <Button className={t9} isExternal={isExternal} {...commonProps} />;
          $[21] = commonProps;
          $[22] = isExternal;
          $[23] = t9;
          $[24] = t10;
        } else {
          t10 = $[24];
        }
        return t10;
      }
    case "next-button-secondary":
      {
        let t9;
        if ($[25] !== className) {
          t9 = classnames(className, styles.button);
          $[25] = className;
          $[26] = t9;
        } else {
          t9 = $[26];
        }
        let t10;
        if ($[27] !== commonProps || $[28] !== isExternal || $[29] !== t9) {
          t10 = <Button className={t9} isExternal={isExternal} variant={ButtonVariant.Secondary} {...commonProps} />;
          $[27] = commonProps;
          $[28] = isExternal;
          $[29] = t9;
          $[30] = t10;
        } else {
          t10 = $[30];
        }
        return t10;
      }
    case "next-text-icon":
      {
        let t9;
        if ($[31] !== textIconProps) {
          t9 = <Button {...textIconProps} />;
          $[31] = textIconProps;
          $[32] = t9;
        } else {
          t9 = $[32];
        }
        return t9;
      }
    case "next-text-icon-small":
      {
        let t9;
        if ($[33] !== textIconProps) {
          t9 = <Button isSmall={true} {...textIconProps} />;
          $[33] = textIconProps;
          $[34] = t9;
        } else {
          t9 = $[34];
        }
        return t9;
      }
    case "next-text-small":
    default:
      {
        let t9;
        if ($[35] !== className) {
          t9 = classnames(className);
          $[35] = className;
          $[36] = t9;
        } else {
          t9 = $[36];
        }
        let t10;
        if ($[37] !== commonProps || $[38] !== isExternal || $[39] !== t9) {
          t10 = <Button className={t9} isExternal={isExternal} isSmall={true} variant={ButtonVariant.Tertiary} {...commonProps} />;
          $[37] = commonProps;
          $[38] = isExternal;
          $[39] = t9;
          $[40] = t10;
        } else {
          t10 = $[40];
        }
        return t10;
      }
  }
};